module.exports = __webpack_public_path__ + "static/media/join.b19a3675.png";